import React, { useEffect } from "react";
import { webcamInstance } from "../Artist/js/Lotus-Webcam";
import { createLotusLedByLight } from "../Artist/js/Lotus-LedByLight";
import {
  LotusWebcamWrapper,
  LotusContainer,
} from "../styles/components/Global/Artwork";

const LotusWebcam = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      import("p5").then(p5 => {
        let webcamSketch = null;
        let ledByLightSketch = null;

        webcamSketch = new p5.default(p => webcamInstance(p));
        ledByLightSketch = new p5.default(
          p => createLotusLedByLight(p, webcamSketch),
          "lotus_ledbylight"
        );
      });
    }
  }, []);

  return (
    <LotusWebcamWrapper>
      <LotusContainer>
        <div id="lotus_ledbylight"></div>
      </LotusContainer>
    </LotusWebcamWrapper>
  );
};

export default LotusWebcam;
